import { AlertType } from "../provider/AlertProvider";

import * as Common from "../commons/common";

import CryptoJS from "crypto-js";
import moment from "moment";

declare const window: typeof globalThis & {
    Android: any;
    webkit: any;
};

export const initModalStack = () => {
    sessionStorage.setItem(Common.SESSION_SHOW_MODAL, String(0));
};

export const addModalStack = () => {
    let currStack = getModalStack();
    currStack++;
    sessionStorage.setItem(Common.SESSION_SHOW_MODAL, String(currStack));
};

export const popModalStack = () => {
    let currStack = getModalStack();
    currStack--;
    if (currStack < 0) currStack = 0;
    sessionStorage.setItem(Common.SESSION_SHOW_MODAL, String(currStack));
};

export const getModalStack = () => {
    return Number(sessionStorage.getItem(Common.SESSION_SHOW_MODAL));
};

export const initDrawerStack = () => {
    sessionStorage.setItem(Common.SESSION_SHOW_DRAWER, String(0));
};

export const addDrawerStack = () => {
    let currStack = getDrawerStack();
    currStack++;
    sessionStorage.setItem(Common.SESSION_SHOW_DRAWER, String(currStack));
};

export const popDrawerStack = () => {
    let currStack = getDrawerStack();
    currStack--;
    if (currStack < 0) currStack = 0;
    sessionStorage.setItem(Common.SESSION_SHOW_DRAWER, String(currStack));
};

export const getDrawerStack = () => {
    return Number(sessionStorage.getItem(Common.SESSION_SHOW_DRAWER));
};

export const sendFCMToken = () => {
    const token = JSON.parse(getLocalStorage(Common.CONTEXT_AUTH) || "{}").token;
    const user = JSON.parse(getLocalStorage(Common.CONTEXT_AUTH) || "{}").user;
    if (token && user) {
        if (window.Android) window.Android.sendFCMToken(user.email, token);
        else if (window.webkit) {
            const message = {
                username: user.email,
                loginToken: token,
            };

            window.webkit.messageHandlers.sendFCMToken.postMessage(message);
        } else console.log("Not Android");
    }
};

const secretPass = "RUTA40";
export const getLocalStorage = (key: string) => {
    const item = localStorage.getItem(key);
    if (item === undefined || item === null) return item;

    const decrypted = CryptoJS.AES.decrypt(item, secretPass);

    try {
        const converted = decrypted.toString(CryptoJS.enc.Utf8);
        return converted;
    } catch (error) {
        removeLocalStorage(key);
        return undefined;
    }
};

export const setLocalStorage = (key: string, value: string) => {
    const encryped = CryptoJS.AES.encrypt(value, secretPass).toString();
    return localStorage.setItem(key, encryped);
};

export const removeLocalStorage = (key: string) => {
    return localStorage.removeItem(key);
};

export const utcToLocalTime = (utcTime: string, format: string) => {
    const localTime = moment.utc(utcTime).toDate();
    return moment(localTime).format(format);
};

export const checkUnAuthorizedToken = (error: any | null) => {
    if (error === null) return false;

    if (error.response.data.code === AlertType.UNAUTHORIZED && error.response.data.message === "Unauthorized token") {
        return true;
    }

    return false;
};

export const convertSubBatteryStatus = (status: "NORMAL" | "LOW" | "VERY_LOW") => {
    let convetString = "";
    switch (status) {
        case "NORMAL": {
            convetString = "정상";
            break;
        }

        case "LOW": {
            convetString = "방전 주의";
            break;
        }

        case "VERY_LOW": {
            convetString = "방전 위험";
            break;
        }

        default:
            break;
    }

    return convetString;
};

export const onEvent = (eventType: string, listener: (event?: any) => void) => {
    document.addEventListener(eventType, listener);
};

export const offEvent = (eventType: string, listener: (event?: any) => void) => {
    document.removeEventListener(eventType, listener);
};

export const onceEvent = (eventType: string, listener: (event?: any) => void) => {
    onEvent(eventType, handleEventOnce);

    function handleEventOnce() {
        listener();
        offEvent(eventType, handleEventOnce);
    }
};

export const triggerEvent = (eventType: string, data?: any) => {
    const event = new CustomEvent(eventType, { detail: data });
    document.dispatchEvent(event);
};

export const isPossibleAutoLogin = () => {
    const savedEmail = getLocalStorage(Common.CONTEXT_SAVED_EMAIL);
    const savedPassword = getLocalStorage(Common.CONTEXT_SAVED_PASSWORD);
    if (savedEmail && savedEmail.length > 0 && savedPassword && savedPassword.length) {
        return { isPossible: true, email: savedEmail, password: savedPassword };
    }

    return { isPossible: false };
};

export const validateEmail = (isFullType: boolean, hasRequired: boolean, value: string) => {
    const emailPattern = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const localPart = value.split("@")[0] || "";
    const domainPart = value.split("@")[1] || "";

    if (!value || !emailPattern.test(value) || localPart.length === 0 || domainPart.length === 0) {
        if (!hasRequired || value) {
            return Promise.reject(new Error("이메일을 입력해 주세요."));
        }
    }

    const localPartPattern = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-z0-9!#$%&'*+/=?^_`{}|~.-]+$/i;
    const domainPartPattern = /^(|[a-z0-9]([a-z0-9.-]*[a-z0-9])?)$/i;

    if (!localPartPattern.test(localPart) || !domainPartPattern.test(domainPart) || value.includes("..") || value.startsWith(".") || value.endsWith(".")) {
        return Promise.reject(new Error("영문자, 숫자 및 일부 특수문자만 입력 가능합니다."));
    }

    if (!isFullType) {
        if (localPart.length > 64) {
            return Promise.reject(new Error("@ 앞 아이디 부분은 최대 64자까지 입력할 수 있습니다."));
        }

        if (domainPart.length > 190) {
            return Promise.reject(new Error("@ 이후 도메인 값은 최대 190자까지 입력할 수 있습니다."));
        }
    }

    if (value.length > 320) {
        return Promise.reject(new Error("최대 320자까지 입력할 수 있습니다."));
    }

    return Promise.resolve();
};
